/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Swipe4Work Admin API
 * OpenAPI spec version: 0.1.1
 */

export type CreateCompanyFromAdminCreationType = typeof CreateCompanyFromAdminCreationType[keyof typeof CreateCompanyFromAdminCreationType];


export const CreateCompanyFromAdminCreationType = {
  Lead: 'Lead',
  MatchCredits: 'MatchCredits',
  JobSlots: 'JobSlots',
} as const;
